import { goldenLines } from "@/mocks/dashan";

export default function GoldenLines() {
  return (
    <section id="lines" className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 text-accent-700 text-sm font-medium">
            <i className="ri-double-quotes-l"></i> 金句墙
          </span>
          <h3 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            一句顶一万句的开场
          </h3>
          <p className="mt-3 text-foreground-600 leading-relaxed">
            这些话术被无数吃瓜群众反复转发。它们不在词藻，而在那句「我看见了真实的你」的潜台词。
          </p>
        </div>

        <div className="mt-10 columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-5 [&>*]:mb-4 md:[&>*]:mb-5">
          {goldenLines.map((g, i) => (
            <blockquote
              key={g.text}
              className="break-inside-avoid rounded-2xl border border-background-200 bg-background-100/50 p-5 md:p-6"
            >
              <div className="flex items-center justify-between text-xs text-foreground-400">
                <span>第 {String(i + 1).padStart(2, "0")} 句</span>
                <span className="text-primary-500">
                  <i className="ri-heart-3-fill"></i> {g.likes}
                </span>
              </div>
              <p className="mt-3 font-heading text-lg md:text-xl font-semibold text-foreground-950 leading-relaxed">
                “{g.text}”
              </p>
              <div className="mt-4 flex items-center gap-2">
                <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs">
                  {g.type}
                </span>
                <button
                  className="ml-auto inline-flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-600 cursor-pointer transition-colors"
                  aria-label="复制这句金句"
                >
                  <i className="ri-file-copy-line"></i> 复制
                </button>
              </div>
            </blockquote>
          ))}
        </div>

        <p className="mt-8 text-center text-xs text-foreground-500">
          <i className="ri-lightbulb-line mr-1"></i>
          金句是鱼，看懂它背后的「共情点」才是渔。别生搬硬套，先读场景再开口。
        </p>
      </div>
    </section>
  );
}